import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  gap: 32px;
  
  @media (min-width: ${breakpoints.tablet}) {
  }

  @media (min-width: ${breakpoints.desktop}) {
    width: 624px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  @media (min-width: ${breakpoints.tablet}) {
  }

  @media (min-width: ${breakpoints.desktop}) {
  }
`;

export const Paragraph = styled.p`
  margin: 0;
  font-weight: 400;
  color: ${colors.$262626};
`;

export const Title = styled(Paragraph)`
  font-family: ${fonts.exbold};
  ${pxToCssFont(35, 38)}
  color: ${colors.$e60000};
  padding-bottom: 8px;
  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(42, 52)}
  }
`;

export const Subtitle = styled(Paragraph)`
  font-family: ${fonts.exbold};
  ${pxToCssFont(24, 28)}

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(24, 30)}
  }
`;

export const Description = styled(Paragraph)`
  font-family: ${fonts.regular};
  align-items: center;
  align-self: stretch;
  ${pxToCssFont(20, 26)}

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 30)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(20, 26)}
  }
`;


export const ButtonContainer = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 16px;

  div {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: clamp(14px, 3vw, 18px);
    line-height: 22.1px;
    font-family: ${fonts.regular};
    @media (min-width: ${breakpoints.desktop}) {
      width: 296px;
    }
    a {
      color: ${colors.$ffffff} !important;
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: column;
    font-size: 14px;
    margin-top: 18px;
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin-top: 0px;
    flex-direction: row;
    width: 100%;
  }
`;